import React from 'react';
import { Helmet } from "react-helmet";

const SEO = ({ title }) => {
  return (
    <Helmet>
      <title>NYADS IT Solutions {title}</title>
    </Helmet>
  );
};

export default SEO;
